import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import IssuesControlPanel from '../components/issues-control-panel/IssuesControlPanel';
import { useState } from 'react';
import { useSnapshot } from 'valtio';
import IssuesStore from '../../active-issues/stores/issues-store';

const IssuesControlsContainer = () => {
  const { classes } = useStyles();

  const [openExportIssuesMenu, setOpenExportIssuesMenu] = useState(false);
  const { searchValue, numberOfFilters } = useSnapshot(IssuesStore);
  return (
    <div className={classes.container}>
      <IssuesControlPanel
        searchValue={searchValue}
        openExportIssuesMenu={openExportIssuesMenu}
        setOpenExportIssuesMenu={setOpenExportIssuesMenu}
        numberOfFilters={numberOfFilters}
      />
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    marginBlock: theme.spacing(1),
  },
}));

export default IssuesControlsContainer;
